import React from 'react';
import { Button, Divider, message } from 'antd';

import { formatPrice } from '../../../data/helpers';

import {
  SummaryCard,
  SummaryTitle,
  SummaryRow,
  SummaryTotal,
} from '../styles';

const SHIPPING_COST = 1500;

export default function OrderSummary({ cartItems }) {
  const subtotal = cartItems.reduce((sum, item) => sum + item.price, 0);
  const total = subtotal + SHIPPING_COST;

  const handleCheckout = () => {
    message.info('Próximamente');
  };

  return (
    <SummaryCard>
      <SummaryTitle>Resumen del pedido</SummaryTitle>
      <SummaryRow>
        <span>Subtotal ({cartItems.length} {cartItems.length === 1 ? 'artículo' : 'artículos'})</span>
        <span>{formatPrice(subtotal)}</span>
      </SummaryRow>
      <SummaryRow>
        <span>Envío estimado</span>
        <span>{formatPrice(SHIPPING_COST)}</span>
      </SummaryRow>
      <Divider style={{ margin: '8px 0' }} />
      <SummaryTotal>
        <span>Total</span>
        <span>{formatPrice(total)}</span>
      </SummaryTotal>
      <Button
        type="primary"
        size="large"
        block
        style={{ marginTop: 20 }}
        onClick={handleCheckout}
      >
        Proceder al pago
      </Button>
    </SummaryCard>
  );
}
